export function CreateFromCopyIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Create from copy"
    >
      <path
        d="M2.75 13.6875H8.875C9.11563 13.6875 9.3125 13.4906 9.3125 13.25V11.9375H10.625V13.25C10.625 14.2152 9.84023 15 8.875 15H2.75C1.78477 15 1 14.2152 1 13.25V7.125C1 6.15977 1.78477 5.375 2.75 5.375H4.0625V6.6875H2.75C2.50937 6.6875 2.3125 6.88438 2.3125 7.125V13.25C2.3125 13.4906 2.50937 13.6875 2.75 13.6875ZM13.6875 8.875V2.75C13.6875 2.50937 13.4906 2.3125 13.25 2.3125H7.125C6.88438 2.3125 6.6875 2.50937 6.6875 2.75V8.875C6.6875 9.11563 6.88438 9.3125 7.125 9.3125H13.25C13.4906 9.3125 13.6875 9.11563 13.6875 8.875ZM7.125 10.625C6.15977 10.625 5.375 9.84023 5.375 8.875V2.75C5.375 1.78477 6.15977 1 7.125 1H13.25C14.2152 1 15 1.78477 15 2.75V8.875C15 9.84023 14.2152 10.625 13.25 10.625H7.125ZM10.1875 3.625C10.5512 3.625 10.8438 3.91758 10.8438 4.28125V5.15625H11.7188C12.0824 5.15625 12.375 5.44883 12.375 5.8125C12.375 6.17617 12.0824 6.46875 11.7188 6.46875H10.8438V7.34375C10.8438 7.70742 10.5512 8 10.1875 8C9.82383 8 9.53125 7.70742 9.53125 7.34375V6.46875H8.65625C8.29258 6.46875 8 6.17617 8 5.8125C8 5.44883 8.29258 5.15625 8.65625 5.15625H9.53125V4.28125C9.53125 3.91758 9.82383 3.625 10.1875 3.625Z"
        fill="currentColor"
      />
    </svg>
  );
}
